import { koComponent } from '../../ko-utils';
import $api from '../../api';
import { UserModel } from '../../models/Gen/BaseModels';
import Pager from '../../components/pager';

class ActivitiesView {
    constructor(params) {
        Pager();

        this.logs = ko.observableArray();
        this.pageInfo = {};

        this.users = ko.observableArray();

        document.addEventListener('loadActivityLogs', () => {
            this.load();
        });
    }

    load() {
        this.getPage(1, 20);
    }

    loadMore() {
        this.getPage(this.pageInfo.page + 1, 20);
    }

    getPage(page, pageSize) {
        $api.activitylogs.search(
            { projectCode: auth.project.UniqueCode },
            {
                page,
                pageSize
            },
            (res) => {
                this.pageInfo.page = page;
                this.pageInfo.pageSize = pageSize;

                this.setLogsFromPagedList(res);
            }
        );
    }

    setLogsFromPagedList(pagesList) {
        let res = [];
        for (var log of pagesList.items) {
            res.push(log);
        }
        this.logs(this.logs().concat(res));
    }

    getUrlByType(type, id) {
        if (type >= 10 && type <= 19) {
            return '/' + auth.project.UniqueCode + '/tours/detail/' + id;
        } else if (type >= 20 && type <= 29) {
            return '/' + auth.project.UniqueCode + '/contexthelp/detail/' + id;
        } else if (type >= 30 && type <= 39) {
            return '/' + auth.project.UniqueCode + '/changelogs/detail/' + id;
        } else if (type >= 40 && type <= 49) {
            return '#';
        }
    }

    getTextType(type) {
        /**
         TourPublished = 10,
        TourUnpublished = 11,
        TourDeleted = 12,
        TourRestarted = 13,

        ContextHelpPublished = 20,
        ContextHelpUnublished = 21,
        ContextHelpDeleted = 22,

        ChangelogPublished = 30,
        ChangelogUnpublished = 31,
        ChangelogDeleted = 32,

        FeedbackResolved = 40,
        FeedbackUnresolved = 41,
        FeedbackDeleted = 42
         */

        switch (type) {
            case 10: return 'Tour published';
            case 11: return 'Tour unpublished';
            case 12: return 'Tour deleted';
            case 13: return 'Tour restarted';

            case 20: return 'Hints published';
            case 21: return 'Hints unpublished';
            case 22: return 'Hints deleted';

            case 30: return 'Changelog published';
            case 31: return 'Changelog unpublished';
            case 32: return 'Changelog deleted';

            case 40: return 'Feedback resolved';
            case 41: return 'Feedback unresolved';
            case 42: return 'Feedback deleted';
        }
    }
}

export default koComponent('activities-view', ActivitiesView);